<template>
    <el-row>
        <el-form :model="weChartPayConfigForm"
                 ref="weChartPayConfigRef"
                 :rules="weChartPayConfigForm.useProxy!==1?rules1:rules2"
                 @onSelectInfo="onSelectInfo"
                 addAction=""
                 editAction="/dbtCard/settingMchId.action"
                 selectAction="/dbtCard/selectMchIdInfo.action"
                 label-width="150px"
                 style="width:50%"
                 v-form>
            <el-form-item label="收款商户号" prop="mchId">
                <el-input placeholder="收款商户号" v-model="weChartPayConfigForm.mchId"></el-input>
            </el-form-item>
            <el-form-item label="收款商户全称" prop="mchName">
                <el-input placeholder="收款商户全称" v-model="weChartPayConfigForm.mchName"></el-input>
            </el-form-item>
          <el-form-item v-show="weChartPayConfigForm.useProxy===1" ref="refoutMchId" label="出款商户号" prop="outMchId">
            <el-input placeholder="出款商户号" v-model="weChartPayConfigForm.outMchId"></el-input>
          </el-form-item>
          <el-form-item v-show="weChartPayConfigForm.useProxy===1" label="出款商户全称" prop="outMchName">
            <el-input placeholder="出款商户全称" v-model="weChartPayConfigForm.outMchName"></el-input>
          </el-form-item>
            <el-form-item label="出款账号" prop="useProxy">
                <el-radio-group v-model="weChartPayConfigForm.useProxy" >
                    <el-radio :label="1">服务商微信商户</el-radio>
                    <el-radio :label="2">代理微信商户(1611839575)</el-radio>
                    <el-radio :label="3">代理支付宝(57054086@qq.com)</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button type="primary">确定</el-button>
                <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
        </el-form>
    </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'

export default {
  name: 'weChartPayConfig',
  extends: BasicPager,
  components: {},
  data: function () {
    return {
      rules1: {
        mchId: [{ required: true, message: '商户号不能为null' }],
        mchName: [{ required: true, message: '商户全称不能为null' }]

      },
      rules2: {
        mchId: [{ required: true, message: '商户号不能为null' }],
        mchName: [{ required: true, message: '商户全称不能为null' }],
        outMchId: [{ required: true, message: '商户号不能为null' }],
        outMchName: [{ required: true, message: '商户全称不能为null' }]
      },
      weChartPayConfigForm: {
        id: null,
        mchName: null,
        mchId: null,
        outMchId: null,
        outMchName: null
      }
    }
  },
  created () {
    this.weChartPayConfigForm.id = this.$route.query.id
  },
  methods: {
    onFilterParams: function (params) {

    },
    onSelectInfo: function (dataInfo) {}
  },
  filters: {}

}
</script>

<style scoped>

</style>
